module.exports = __webpack_public_path__ + "static/logo-ptpn-5-b2ba40ff3b2d3621c5cbbee9bbf01cda.png";